import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: 'app-duplicate-plans',
  // imports: [],
  templateUrl: './duplicate-plans.component.html',
  styleUrl: './duplicate-plans.component.css',
  standalone: false,
})
export class DuplicatePlansComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
